<template>
    <div class="mb-primary">
        <div class="card template-preview-card border-0 mb-2">
            <div class="template-preview-wrapper p-3 rounded" @click="selectedTemplateCard"
                 :style="[previewType==='image'? {'backgroundImage': 'url('+generateBackgroundImage()+')'} : null]">
                <iframe
                    v-if="previewType==='html'"
                    class="template-preview-iframe"
                    :srcdoc="getIframeContent"
                    sandbox="allow-same-origin"
                    scrolling="no"
                    frameborder="0"
                ></iframe>
                <div v-if="showAction" class="card-overlay-options">
                    <ul class="list-group h-100">
                        <li v-for="(action,index) in actions" :key="index" v-if="checkModifier(action)"
                            class="list-group-item">
                            <a class="d-block" href="#" target="_blank" @click.prevent="callAction(action)">
                                <app-icon :name="action.icon"/>
                                <span class="ml-3">{{ action.title }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <h5 class="text-muted card-subject">{{ card[subjectKey] }}</h5>
    </div>
</template>

<script>
import AppFunction from "../../helpers/app/AppFunction";
import {purify} from "../../helpers/purifier/HTMLPurifyHelper";

export default {
    name: "AppTemplatePreviewCard",
    props: {
        subjectKey: {
            type: String,
            default: 'subject'
        },
        defaultContentKey: {
            type: String,
            default: 'default_content'
        },
        customContentKey: {
            type: String,
            default: 'custom_content'
        },
        actions: {
            type: Array,
            require: true
        },
        showAction: {
            type: Boolean,
            default: true
        },
        card: {
            type: Object,
            require: true
        },
        id: {
            type: String,
            require: true
        },
        previewType: {
            type: String,
            default: 'html'
        },
        previewImageKey: {
            type: Object
        }
    },
    data(){
        return{
            purify,
        }
    },
    computed: {
        getIframeContent() {
            const content = this.card[this.customContentKey] || this.card[this.defaultContentKey] || '';
            // Wrap content in a basic HTML document structure if not already a full document
            // Add base styles to scale content appropriately for preview
            const baseStyles = `
                <style>
                    html, body {
                        margin: 0;
                        padding: 0;
                        overflow: hidden;
                        transform-origin: top left;
                        transform: scale(0.4);
                        width: 250%;
                    }
                </style>
            `;
            // If content already has html/body tags, inject our styles
            if (content.toLowerCase().includes('<html') || content.toLowerCase().includes('<body')) {
                return content.replace(/<head>/i, '<head>' + baseStyles);
            }
            // Otherwise wrap in a full document
            return `<!DOCTYPE html><html><head>${baseStyles}</head><body>${content}</body></html>`;
        }
    },
    methods: {
        checkModifier(action) {
            if (action?.modifier) {
                if (action.modifier(this.card) == false) {
                    return false
                } else return true;
            } else return true
        },

        selectedTemplateCard() {
            if (this.showAction == false)
                this.$hub.$emit('TemplateCard-' + this.id, this.card);
        },
        callAction(action) {
            this.$hub.$emit('action-' + this.id, this.card, action, true)
        },
        generateBackgroundImage() {
            if (this.card[this.previewImageKey.relation]) {
                if (this.card[this.previewImageKey.relation][this.previewImageKey.key]) {
                    return this.card[this.previewImageKey.relation][this.previewImageKey.key];
                } else return AppFunction.getAppUrl('images/default-card-view-img.png');
            } else return AppFunction.getAppUrl('images/default-card-view-img.png');
        }
    }
}
</script>

<style scoped>
.template-preview-iframe {
    width: 100%;
    height: 280px;
    border: none;
    pointer-events: none;
    background: #fff;
    border-radius: 4px;
}
</style>
